export const AUTO_REPLY_SUPPRESSED_MESSAGE = 'AUTO_REPLY_SUPPRESSED_MESSAGE';